"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const jsxRuntime = require("react/jsx-runtime");
const React = require("react");
const useFormValidationState = require("../../../../chunks/useFormValidationState-DUZahEdK.js");
const clsx = require("../../../../chunks/clsx-CBkIpawf.js");
const foundations_typography_Text_Text = require("../../../../foundations/typography/Text/Text.js");
const components_input_elements_unstyled_CheckboxBase_hooks_useCheckboxContext = require("../unstyled/CheckboxBase/hooks/useCheckboxContext.js");
const helpers_module = require("../../../../chunks/helpers.module-CyAR4a3K.js");
const utils = require("../../../../chunks/utils-Y4id5lfu.js");
const mergeProps = require("../../../../chunks/mergeProps-AWQ5Mc81.js");
const filterDOMProps = require("../../../../chunks/filterDOMProps-DSqQIo6b.js");
const useField = require("../../../../chunks/useField-1Oa9bSpn.js");
const useFocusWithin = require("../../../../chunks/useFocusWithin-DJC0ie9P.js");
function $1e9fce0cfacc738b$export$49ff6f28c54f1cbe(props, state) {
  let { isDisabled, name, form, validationBehavior = "aria" } = props;
  let { isInvalid, validationErrors, validationDetails } = state.displayValidation;
  let { labelProps, fieldProps, descriptionProps, errorMessageProps } = useField.$2baaea4c71418dea$export$294aa081a6c6f55d({
    ...props,
    // Checkbox group is not an HTML input element so it
    // shouldn't be labeled by a <label> element.
    labelElementType: "span",
    isInvalid,
    errorMessage: props.errorMessage || validationErrors
  });
  utils.$1ae600c947479353$export$ec98120685d4f57d.set(state, {
    name,
    form,
    descriptionId: descriptionProps.id,
    errorMessageId: errorMessageProps.id,
    validationBehavior
  });
  let domProps = filterDOMProps.$65484d02dcb7eb3e$export$457c3d6518dd4c6f(props, {
    labelable: true
  });
  let { focusWithinProps } = useFocusWithin.$9ab94262bd0047c7$export$420e68273165f4ec({
    onBlurWithin: props.onBlur,
    onFocusWithin: props.onFocus,
    onFocusWithinChange: props.onFocusChange
  });
  return {
    groupProps: mergeProps.$3ef42575df84b30b$export$9d1611c77c2fe928(domProps, {
      role: "group",
      "aria-disabled": isDisabled || void 0,
      ...fieldProps,
      ...focusWithinProps
    }),
    labelProps,
    descriptionProps,
    errorMessageProps,
    isInvalid,
    validationErrors,
    validationDetails
  };
}
function $587d3ad58be6d31f$export$daff6da51032a415(props = {}) {
  let [selectedValues, setValue] = useFormValidationState.$458b0a5536c1a7cf$export$40bfa8c7b0832715(props.value, props.defaultValue || [], props.onChange);
  let [initialValues] = React.useState(selectedValues);
  let isRequired = !!props.isRequired && selectedValues.length === 0;
  let invalidValues = React.useRef(/* @__PURE__ */ new Map());
  let validation = useFormValidationState.$e5be200c675c3b3a$export$fc1a364ae1f3ff10({
    ...props,
    value: selectedValues
  });
  let isInvalid = validation.displayValidation.isInvalid;
  var _props_defaultValue, _props_validationState;
  const state = {
    ...validation,
    value: selectedValues,
    defaultValue: (_props_defaultValue = props.defaultValue) !== null && _props_defaultValue !== void 0 ? _props_defaultValue : initialValues,
    setValue(value) {
      if (props.isReadOnly || props.isDisabled) return;
      setValue(value);
    },
    isDisabled: props.isDisabled || false,
    isReadOnly: props.isReadOnly || false,
    isSelected(value) {
      return selectedValues.includes(value);
    },
    addValue(value) {
      if (props.isReadOnly || props.isDisabled) return;
      if (!selectedValues.includes(value)) {
        selectedValues = selectedValues.concat(value);
        setValue(selectedValues);
      }
    },
    removeValue(value) {
      if (props.isReadOnly || props.isDisabled) return;
      if (selectedValues.includes(value)) setValue(selectedValues.filter((existingValue) => existingValue !== value));
    },
    toggleValue(value) {
      if (props.isReadOnly || props.isDisabled) return;
      if (selectedValues.includes(value)) setValue(selectedValues.filter((existingValue) => existingValue !== value));
      else setValue(selectedValues.concat(value));
    },
    setInvalid(value, v) {
      let s = new Map(invalidValues.current);
      if (v.isInvalid) s.set(value, v);
      else s.delete(value);
      invalidValues.current = s;
      validation.updateValidation(useFormValidationState.$e5be200c675c3b3a$export$75ee7c75d68f5b0e(...s.values()));
    },
    validationState: (_props_validationState = props.validationState) !== null && _props_validationState !== void 0 ? _props_validationState : isInvalid ? "invalid" : null,
    isInvalid,
    isRequired
  };
  return state;
}
const CheckboxGroup = React.forwardRef(
  ({
    children,
    style,
    className,
    showLabel = true,
    labelVariant = "text-body-head",
    labelComponent = "h3",
    labelClassName,
    ...props
  }, ref) => {
    let state = $587d3ad58be6d31f$export$daff6da51032a415(props);
    let { groupProps, labelProps } = $1e9fce0cfacc738b$export$49ff6f28c54f1cbe(props, state);
    return /* @__PURE__ */ jsxRuntime.jsxs(
      "div",
      {
        ...groupProps,
        ref,
        style,
        className: clsx.clsx(groupProps.className, className),
        children: [
          /* @__PURE__ */ jsxRuntime.jsx(
            foundations_typography_Text_Text.Text,
            {
              ...labelProps,
              className: clsx.clsx(labelProps.className, !showLabel && helpers_module.helpers.srOnly, labelClassName),
              variant: labelVariant,
              component: labelComponent,
              children: props.label
            }
          ),
          /* @__PURE__ */ jsxRuntime.jsx(
            components_input_elements_unstyled_CheckboxBase_hooks_useCheckboxContext.CheckboxGroupContext.Provider,
            {
              value: {
                state
              },
              children
            }
          )
        ]
      }
    );
  }
);
exports.CheckboxGroup = CheckboxGroup;
